/* eslint jsx-a11y/no-static-element-interactions: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */

import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { LegacyIcon } from '../../icon/Legacy';

const failInternal = 'Smart Edge Monitoring capture internal error';
const failCaptureFile = 'Smart Edge Monitoring capture write error, no space left on disk';
const failMissing = 'Smart Edge Monitoring capture discarded due to capture errors';
const failSend = 'Failed to send Smart Edge Monitoring capture to nGeniusPULSE server';

const captureErrorTable = {
    CAPTURE_ERROR_NONE: 'No error',
    CAPTURE_ERROR_FILTER: failInternal,
    CAPTURE_ERROR_EVENTS: failInternal,
    CAPTURE_ERROR_INTERFACE: failInternal,
    CAPTURE_ERROR_THREAD: failInternal,
    CAPTURE_ERROR_MISSED_BEACON: failMissing,
    CAPTURE_ERROR_CREATE_CAPTURE_FILE: failCaptureFile,
    CAPTURE_ERROR_OPEN_CAPTURE_FILE: failCaptureFile,
    CAPTURE_ERROR_WRITE_CAPTURE_FILE: failCaptureFile,
    CAPTURE_ERROR_RENAME_CAPTURE_FILE: failCaptureFile,
    CAPTURE_ERROR_READ_PACKET: failInternal,
    CAPTURE_ERROR_CREATE_BUNDLE_FILE: failCaptureFile,
    CAPTURE_ERROR_OPEN_BUNDLE_FILE: failCaptureFile,
    CAPTURE_ERROR_SEND_BUNDLE_FILE: failSend,
    CAPTURE_ERROR_CREATE_CURL: failInternal,
};
const getErrorString = (msg) => captureErrorTable[msg] || 'unknown error';

const useStyles = makeStyles(() => ({
    semCaptureInfo: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        '& .MuiIcon-root': {
            fontSize: '16px',
        },
    },
}));

function SemColumn({ row }) {
    const semCaptureInfoClass = useStyles();
    const sem_capture_truncated = row['sem-capture-truncated'];
    const sem_capture_error = row['sem-capture-error'];
    const hasSemIssue = !_.isEmpty(sem_capture_truncated) || !_.isEmpty(sem_capture_error);
    const semIcon = _.isEmpty(sem_capture_error) ? 'warning' : 'error';
    if (!hasSemIssue) return '';

    return (
        <div className={semCaptureInfoClass.semCaptureInfo}>
            <LegacyIcon icon={semIcon} />
        </div>
    );
}

export function semColumnRenderer(row) {
    if (!row) return null;
    return <SemColumn row={row} />;
}

export function semColumnTooltip(row) {
    const semError = row['sem-capture-error'];
    const semTruncSize = row['sem-capture-truncated'];
    if (semError) return getErrorString(semError);
    if (semTruncSize) return 'Smart Edge Monitoring capture truncated to maximum size';
    return '';
}
